module.exports = __webpack_public_path__ + "static/media/sony-alpha-4.14e902be.jpg";